import { render, staticRenderFns } from "./MemoVersionsDialog.vue?vue&type=template&id=30153b38&scoped=true"
import script from "./MemoVersionsDialog.vue?vue&type=script&lang=ts"
export * from "./MemoVersionsDialog.vue?vue&type=script&lang=ts"
import style0 from "./MemoVersionsDialog.vue?vue&type=style&index=0&id=30153b38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30153b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30153b38')) {
      api.createRecord('30153b38', component.options)
    } else {
      api.reload('30153b38', component.options)
    }
    module.hot.accept("./MemoVersionsDialog.vue?vue&type=template&id=30153b38&scoped=true", function () {
      api.rerender('30153b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MemoVersionsDialog.vue"
export default component.exports